<template>
  <div class='report-container'>
    <div class="input-item">
      <span>店铺名称</span>
      <span>{{ report.shop }}</span>
    </div>
    <div class="input-item">
      <span>店铺地址</span>
      <span>{{ report.shopAddress }}</span>
    </div>
    <div class="input-item">
      <span>反馈类型</span>
      <span>{{report.type | typeFilter}}</span>
    </div>
    <div class="input-item">
      <span>您的姓名</span>
      <span>{{ report.name }}</span>
    </div>
    <div class="input-item">
      <span>联系电话</span>
      <span>{{ report.mobile }}</span>
    </div>
    <div class="textarea-item">
      <span>反馈内容</span>
      <textarea placeholder="请输入反馈内容" disabled v-model="report.message"></textarea>
    </div>
    <div class="textarea-item">
      <span>图片附件（可选）</span>
      <div class='addimage'>
        <div v-for="(item, index) in report.reportAttachmentList" :key="index" style="position: relative;">
          <img class="main-image" :src="item.attachment" @click="previewImage(index)"/>
          <!-- <img src="../../assets/img/img_upload_delete.png" class="del-image" @click.stop="deleteImage(index)"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { Area, Popup, Picker, Toast } from 'vant'
import { ImagePreview } from 'vant'

Vue.use(Popup).use(Area).use(Picker).use(Toast)
export default {
  name: 'ReportDetail',
  data() {
    return {
      report: {}
    }
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getReport()
    }
  },
  filters: {
    typeFilter(type) {
      const typeMap = {
        0: '假货',
        1: '窜货'
      }
      return typeMap[type]
    }
  },
  methods: {
    /**
     * 获取反馈信息
     */
    getReport() {
      var that = this
      console.log(this.$route.params.id)
      this.axios.get('/antifake/report/' + this.$route.params.id + '/').then(function(res) {
        console.log(res.data)
        that.report = res.data
      })
    },

    previewImage(index) {
      var images = []
      for (var item of this.report.reportAttachmentList) {
        images.push(item.attachment)
      }
      ImagePreview({
        images: images,
        startPosition: index,
        loop: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-container{
  padding-bottom: 65px;
  .input-item{
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }
    input{
      width: 250px;
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      text-align: right;
    }
  }
  .textarea-item{
    background-color: #ffffff;
    line-height: 44px;
    margin-bottom: 1px;
    span{
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }
    textarea{
      width: 90%;
      height: 80px;
      padding: 5px;
      font-size: 14px;
      border-color: #ffffff;
      color: #000000;
      resize: none;
      display: block;
      margin: 0 auto;
    }
    .addimage{
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      .add{
        line-height: 0px;
        display: inline-block;
        margin: 28px 15px;
        font-size: 40px;
        color: #dddddd;
      }
      input{
        width: 60px;
        height: 60px;
        position: absolute;
        opacity: 0;
      }
      .main-image{
        width: 60px;
        height: 60px;
        margin: 0 8px 8px 0;
      }
      .del-image{
        width: 25px;
        height: 25px;
        position: absolute;
        top: 0;
        right: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/report/detail.vue